import { RequestServiceInputType } from "pages/OptionCreate/type";
import { today, tomorrow } from "utils/dateUtils";

export const INITIAL_CUSTOM_REQUEST_SERVICES = [
  {
    id: crypto.randomUUID(),
    content: "",
    checked: false,
    usingSpans: [
      {
        id: crypto.randomUUID(),
        usingStartDate: today,
        usingEndDate: tomorrow,
        isOneDay: false,
      },
    ],
  },
  {
    id: crypto.randomUUID(),
    content: "",
    checked: false,
    usingSpans: [
      {
        id: crypto.randomUUID(),
        usingStartDate: today,
        usingEndDate: tomorrow,
        isOneDay: false,
      },
    ],
  },
  {
    id: crypto.randomUUID(),
    content: "",
    checked: false,
    usingSpans: [
      {
        id: crypto.randomUUID(),
        usingStartDate: today,
        usingEndDate: tomorrow,
        isOneDay: false,
      },
    ],
  },
];
